import React, { useMemo } from "react";

// Warm autumn leaf colours (kept independent of the site accent)
const LEAF_COLORS = ["#C2622D", "#D98C3E", "#A6472E", "#E0A458", "#B5533A", "#CE7B3B"];

const LeafShape = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 1.5 C16.5 6 20 8.5 20 13 C20 18 16.4 22.3 12 23 C7.6 22.3 4 18 4 13 C4 8.5 7.5 6 12 1.5 Z"
      fill={color}
    />
    <path d="M12 4 L12 21" stroke="rgba(255,255,255,0.35)" strokeWidth="0.8" strokeLinecap="round" />
    <path d="M12 9 L8.5 7 M12 12 L8 10.5 M12 9 L15.5 7 M12 12 L16 10.5" stroke="rgba(255,255,255,0.25)" strokeWidth="0.7" strokeLinecap="round" />
  </svg>
);

const FallingLeaves = ({ count = 14 }) => {
  const leaves = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = 14 + Math.round(Math.random() * 18);
        return {
          id: i,
          left: Math.random() * 100,
          size,
          color: LEAF_COLORS[i % LEAF_COLORS.length],
          fallDuration: 9 + Math.random() * 9,
          fallDelay: -Math.random() * 12,
          swayDuration: 2.4 + Math.random() * 2.6,
        };
      }),
    [count]
  );

  return (
    <div className="leaves-layer" aria-hidden="true">
      {leaves.map((leaf) => (
        <div
          key={leaf.id}
          className="leaf"
          style={{
            left: `${leaf.left}%`,
            animationDuration: `${leaf.fallDuration}s`,
            animationDelay: `${leaf.fallDelay}s`,
          }}
        >
          <span style={{ animationDuration: `${leaf.swayDuration}s` }}>
            <LeafShape color={leaf.color} size={leaf.size} />
          </span>
        </div>
      ))}
    </div>
  );
};

export default FallingLeaves;
